import React, { useState, useEffect } from "react";
import hero1 from "../assets/Mainimage.png";
import hero2 from "../assets/Mainimage2.png";
import hero3 from "../assets/last 1.jpg";

function HeroSection() {
  const images = [hero1, hero2, hero3];
  const quotes = [
    {
      title: "Providing services",
      line2: "with utmost",
      line3: "integrity and care",
    },
    {
      title: "Empowering independence",
      line2: "with support that",
      line3: "truly matters",
    },
    {
      title: "Building connections",
      line2: "with compassion and",
      line3: "dedicated care",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-change image + text every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  // Manual controls
  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <section
      className="hero-section"
      style={{
        backgroundImage: `url(${images[currentIndex]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "460px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        transition: "background-image 0.8s ease-in-out",
      }}
    >
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1>
          {quotes[currentIndex].title}
          <br />
          {quotes[currentIndex].line2}
          <br />
          {quotes[currentIndex].line3}
        </h1>
        <button className="hero-btn">Know More</button>
      </div>

      {/* Navigation Arrows */}
      <button className="hero-arrow hero-arrow--left" onClick={handlePrev}>
        {"<"}
      </button>
      <button className="hero-arrow hero-arrow--right" onClick={handleNext}>
        {">"}
      </button>
    </section>
  );
}

export default HeroSection;
